goog.provide("shadow.js.shim.module$$mui$material$IconButton");
goog.provide("module$shadow_js_shim_module$$mui$material$IconButton");
shadow.js.shim.module$$mui$material$IconButton = shadow.js.nativeProvides["@mui/material/IconButton"] = shadow$bridge("@mui/material/IconButton");
module$shadow_js_shim_module$$mui$material$IconButton.default = shadow.js.shim.module$$mui$material$IconButton;
